/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { B2BCostCenter } from './B2BCostCenter';
import {
    B2BCostCenterFromJSON,
    B2BCostCenterFromJSONTyped,
    B2BCostCenterToJSON,
} from './B2BCostCenter';
import type { B2BPaymentType } from './B2BPaymentType';
import {
    B2BPaymentTypeFromJSON,
    B2BPaymentTypeFromJSONTyped,
    B2BPaymentTypeToJSON,
} from './B2BPaymentType';
import type { B2BUnit } from './B2BUnit';
import {
    B2BUnitFromJSON,
    B2BUnitFromJSONTyped,
    B2BUnitToJSON,
} from './B2BUnit';
import type { Consignment } from './Consignment';
import {
    ConsignmentFromJSON,
    ConsignmentFromJSONTyped,
    ConsignmentToJSON,
} from './Consignment';
import type { DeliveryMode } from './DeliveryMode';
import {
    DeliveryModeFromJSON,
    DeliveryModeFromJSONTyped,
    DeliveryModeToJSON,
} from './DeliveryMode';
import type { DeliveryOrderEntryGroup } from './DeliveryOrderEntryGroup';
import {
    DeliveryOrderEntryGroupFromJSON,
    DeliveryOrderEntryGroupFromJSONTyped,
    DeliveryOrderEntryGroupToJSON,
} from './DeliveryOrderEntryGroup';
import type { EntryGroup } from './EntryGroup';
import {
    EntryGroupFromJSON,
    EntryGroupFromJSONTyped,
    EntryGroupToJSON,
} from './EntryGroup';
import type { OrderApprovalPermissionResult } from './OrderApprovalPermissionResult';
import {
    OrderApprovalPermissionResultFromJSON,
    OrderApprovalPermissionResultFromJSONTyped,
    OrderApprovalPermissionResultToJSON,
} from './OrderApprovalPermissionResult';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';
import type { PaymentDetails } from './PaymentDetails';
import {
    PaymentDetailsFromJSON,
    PaymentDetailsFromJSONTyped,
    PaymentDetailsToJSON,
} from './PaymentDetails';
import type { PaymentMode } from './PaymentMode';
import {
    PaymentModeFromJSON,
    PaymentModeFromJSONTyped,
    PaymentModeToJSON,
} from './PaymentMode';
import type { PickupOrderEntryGroup } from './PickupOrderEntryGroup';
import {
    PickupOrderEntryGroupFromJSON,
    PickupOrderEntryGroupFromJSONTyped,
    PickupOrderEntryGroupToJSON,
} from './PickupOrderEntryGroup';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Principal } from './Principal';
import {
    PrincipalFromJSON,
    PrincipalFromJSONTyped,
    PrincipalToJSON,
} from './Principal';
import type { PromotionResult } from './PromotionResult';
import {
    PromotionResultFromJSON,
    PromotionResultFromJSONTyped,
    PromotionResultToJSON,
} from './PromotionResult';
import type { SAPAdditionalCostValue } from './SAPAdditionalCostValue';
import {
    SAPAdditionalCostValueFromJSON,
    SAPAdditionalCostValueFromJSONTyped,
    SAPAdditionalCostValueToJSON,
} from './SAPAdditionalCostValue';
import type { SAPAdditionalTotal } from './SAPAdditionalTotal';
import {
    SAPAdditionalTotalFromJSON,
    SAPAdditionalTotalFromJSONTyped,
    SAPAdditionalTotalToJSON,
} from './SAPAdditionalTotal';
import type { SAPCalculationStatus } from './SAPCalculationStatus';
import {
    SAPCalculationStatusFromJSON,
    SAPCalculationStatusFromJSONTyped,
    SAPCalculationStatusToJSON,
} from './SAPCalculationStatus';
import type { SAPDiscountSummary } from './SAPDiscountSummary';
import {
    SAPDiscountSummaryFromJSON,
    SAPDiscountSummaryFromJSONTyped,
    SAPDiscountSummaryToJSON,
} from './SAPDiscountSummary';
import type { SAPFiscalId } from './SAPFiscalId';
import {
    SAPFiscalIdFromJSON,
    SAPFiscalIdFromJSONTyped,
    SAPFiscalIdToJSON,
} from './SAPFiscalId';
import type { SAPGiftCard } from './SAPGiftCard';
import {
    SAPGiftCardFromJSON,
    SAPGiftCardFromJSONTyped,
    SAPGiftCardToJSON,
} from './SAPGiftCard';
import type { SAPGiftCardSummary } from './SAPGiftCardSummary';
import {
    SAPGiftCardSummaryFromJSON,
    SAPGiftCardSummaryFromJSONTyped,
    SAPGiftCardSummaryToJSON,
} from './SAPGiftCardSummary';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';
import type { Voucher } from './Voucher';
import {
    VoucherFromJSON,
    VoucherFromJSONTyped,
    VoucherToJSON,
} from './Voucher';

/**
 * Representation of a order. Note that sapBillingAddress is mutually exclusive with paymentInfo.billingAddress, which is used when the billing address is created concurrently with the paymentInfo. sapBillingAddress is used when there is a need to save the billing address, but the related paymentInfo has not been created yet.
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * Code number of order
     * @type {string}
     * @memberof Order
     */
    code?: string;
    /**
     * Flag stating iv value is net-value
     * @type {boolean}
     * @memberof Order
     */
    net?: boolean;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    totalPriceWithTax?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    totalPrice?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    totalTax?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    subTotal?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    deliveryCost?: Price;
    /**
     * List of order entries
     * @type {Array<OrderEntry>}
     * @memberof Order
     */
    entries?: Array<OrderEntry>;
    /**
     * List of entry groups
     * @type {Array<EntryGroup>}
     * @memberof Order
     */
    entryGroups?: Array<EntryGroup>;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    totalItems?: number;
    /**
     * 
     * @type {DeliveryMode}
     * @memberof Order
     */
    deliveryMode?: DeliveryMode;
    /**
     * 
     * @type {Address}
     * @memberof Order
     */
    deliveryAddress?: Address;
    /**
     * 
     * @type {PaymentDetails}
     * @memberof Order
     */
    paymentInfo?: PaymentDetails;
    /**
     * List of applied order promotions
     * @type {Array<PromotionResult>}
     * @memberof Order
     */
    appliedOrderPromotions?: Array<PromotionResult>;
    /**
     * List of applied product promotions
     * @type {Array<PromotionResult>}
     * @memberof Order
     */
    appliedProductPromotions?: Array<PromotionResult>;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    productDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    orderDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    totalDiscounts?: Price;
    /**
     * Site
     * @type {string}
     * @memberof Order
     */
    site?: string;
    /**
     * Store
     * @type {string}
     * @memberof Order
     */
    store?: string;
    /**
     * Guest user id identifier
     * @type {string}
     * @memberof Order
     */
    guid?: string;
    /**
     * Flag showing if order is calculated
     * @type {boolean}
     * @memberof Order
     */
    calculated?: boolean;
    /**
     * List of applied vouchers
     * @type {Array<Voucher>}
     * @memberof Order
     */
    appliedVouchers?: Array<Voucher>;
    /**
     * 
     * @type {Principal}
     * @memberof Order
     */
    user?: Principal;
    /**
     * List of pickup order entry group
     * @type {Array<PickupOrderEntryGroup>}
     * @memberof Order
     */
    pickupOrderGroups?: Array<PickupOrderEntryGroup>;
    /**
     * List of delivery order entries group
     * @type {Array<DeliveryOrderEntryGroup>}
     * @memberof Order
     */
    deliveryOrderGroups?: Array<DeliveryOrderEntryGroup>;
    /**
     * Quantity of pickup items
     * @type {number}
     * @memberof Order
     */
    pickupItemsQuantity?: number;
    /**
     * Quantity of delivery items
     * @type {number}
     * @memberof Order
     */
    deliveryItemsQuantity?: number;
    /**
     * Customer requested date for order retrieval
     * @type {string}
     * @memberof Order
     */
    requestedRetrievalAt?: string;
    /**
     * 
     * @type {Address}
     * @memberof Order
     */
    sapBillingAddress?: Address;
    /**
     * Email of customer.
     * @type {string}
     * @memberof Order
     */
    sapCustomerEmail?: string;
    /**
     * The payment option identifier. It specifies which option the consumer selected to make the payment for the cart.
     * @type {string}
     * @memberof Order
     */
    sapPaymentOptionId?: string;
    /**
     * 
     * @type {B2BPaymentType}
     * @memberof Order
     */
    paymentType?: B2BPaymentType;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    purchaseOrderNumber?: string;
    /**
     * List of gift cards applied to the cart.
     * @type {Array<SAPGiftCard>}
     * @memberof Order
     */
    sapGiftCards?: Array<SAPGiftCard>;
    /**
     * 
     * @type {SAPGiftCardSummary}
     * @memberof Order
     */
    sapGiftCardSummary?: SAPGiftCardSummary;
    /**
     * 
     * @type {SAPCalculationStatus}
     * @memberof Order
     */
    sapCalculationStatus?: SAPCalculationStatus;
    /**
     * Optionally, services can provide specific summaries of prices, costs and/or taxes, to be displayed to the customer. Those do not affect the Commerce order total. Null when not available.
     * @type {Array<SAPAdditionalTotal>}
     * @memberof Order
     */
    sapAdditionalTotals?: Array<SAPAdditionalTotal>;
    /**
     * Optionally, services can provide specific discount summaries, to be displayed to the customer. Those do not affect the Commerce order total. Null when not available.
     * @type {Array<SAPDiscountSummary>}
     * @memberof Order
     */
    sapDiscountSummaries?: Array<SAPDiscountSummary>;
    /**
     * Additional costs of sales, e.g. DELIVERY, PAYMENT, INSURANCE, HANDLING etc. Null when not available.
     * @type {Array<SAPAdditionalCostValue>}
     * @memberof Order
     */
    sapAdditionalCostValues?: Array<SAPAdditionalCostValue>;
    /**
     * 
     * @type {SAPFiscalId}
     * @memberof Order
     */
    sapCustomerFiscalId?: SAPFiscalId;
    /**
     * 
     * @type {Price}
     * @memberof Order
     */
    totalOrderDiscounts?: Price;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    pakkeboksId?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    rekvisition?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    entryCode?: string;
    /**
     * 
     * @type {PaymentMode}
     * @memberof Order
     */
    paymentMode?: PaymentMode;
    /**
     * 
     * @type {Address}
     * @memberof Order
     */
    paymentAddress?: Address;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    flexDeliveryComment1?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    flexDeliveryComment2?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    actingUserId?: string;
    /**
     * Date of order creation
     * @type {Date}
     * @memberof Order
     */
    created?: Date;
    /**
     * Status of order
     * @type {string}
     * @memberof Order
     */
    status?: string;
    /**
     * Status display
     * @type {string}
     * @memberof Order
     */
    statusDisplay?: string;
    /**
     * Flag showing if customer is Guest customer
     * @type {boolean}
     * @memberof Order
     */
    guestCustomer?: boolean;
    /**
     * List of consignment
     * @type {Array<Consignment>}
     * @memberof Order
     */
    consignments?: Array<Consignment>;
    /**
     * Order delivery status
     * @type {string}
     * @memberof Order
     */
    deliveryStatus?: string;
    /**
     * Order delivery status display
     * @type {string}
     * @memberof Order
     */
    deliveryStatusDisplay?: string;
    /**
     * List of unconsigned order entries
     * @type {Array<OrderEntry>}
     * @memberof Order
     */
    unconsignedEntries?: Array<OrderEntry>;
    /**
     * Boolean flag showing if order is cancellable
     * @type {boolean}
     * @memberof Order
     */
    cancellable?: boolean;
    /**
     * Boolean flag showing if order is returnable
     * @type {boolean}
     * @memberof Order
     */
    returnable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    totalUnitCount?: number;
    /**
     * 
     * @type {User}
     * @memberof Order
     */
    orgCustomer?: User;
    /**
     * 
     * @type {B2BCostCenter}
     * @memberof Order
     */
    costCenter?: B2BCostCenter;
    /**
     * Results of permissions associated with the order
     * @type {Array<OrderApprovalPermissionResult>}
     * @memberof Order
     */
    permissionResults?: Array<OrderApprovalPermissionResult>;
    /**
     * 
     * @type {B2BUnit}
     * @memberof Order
     */
    orgUnit?: B2BUnit;
    /**
     * Quote Code associated with the Order. The Quote Code is present if the order was placed from a quote.
     * @type {string}
     * @memberof Order
     */
    sapQuoteCode?: string;
}

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderFromJSON(json: any): Order {
    return OrderFromJSONTyped(json, false);
}

export function OrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Order {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'net': !exists(json, 'net') ? undefined : json['net'],
        'totalPriceWithTax': !exists(json, 'totalPriceWithTax') ? undefined : PriceFromJSON(json['totalPriceWithTax']),
        'totalPrice': !exists(json, 'totalPrice') ? undefined : PriceFromJSON(json['totalPrice']),
        'totalTax': !exists(json, 'totalTax') ? undefined : PriceFromJSON(json['totalTax']),
        'subTotal': !exists(json, 'subTotal') ? undefined : PriceFromJSON(json['subTotal']),
        'deliveryCost': !exists(json, 'deliveryCost') ? undefined : PriceFromJSON(json['deliveryCost']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(OrderEntryFromJSON)),
        'entryGroups': !exists(json, 'entryGroups') ? undefined : ((json['entryGroups'] as Array<any>).map(EntryGroupFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'deliveryMode': !exists(json, 'deliveryMode') ? undefined : DeliveryModeFromJSON(json['deliveryMode']),
        'deliveryAddress': !exists(json, 'deliveryAddress') ? undefined : AddressFromJSON(json['deliveryAddress']),
        'paymentInfo': !exists(json, 'paymentInfo') ? undefined : PaymentDetailsFromJSON(json['paymentInfo']),
        'appliedOrderPromotions': !exists(json, 'appliedOrderPromotions') ? undefined : ((json['appliedOrderPromotions'] as Array<any>).map(PromotionResultFromJSON)),
        'appliedProductPromotions': !exists(json, 'appliedProductPromotions') ? undefined : ((json['appliedProductPromotions'] as Array<any>).map(PromotionResultFromJSON)),
        'productDiscounts': !exists(json, 'productDiscounts') ? undefined : PriceFromJSON(json['productDiscounts']),
        'orderDiscounts': !exists(json, 'orderDiscounts') ? undefined : PriceFromJSON(json['orderDiscounts']),
        'totalDiscounts': !exists(json, 'totalDiscounts') ? undefined : PriceFromJSON(json['totalDiscounts']),
        'site': !exists(json, 'site') ? undefined : json['site'],
        'store': !exists(json, 'store') ? undefined : json['store'],
        'guid': !exists(json, 'guid') ? undefined : json['guid'],
        'calculated': !exists(json, 'calculated') ? undefined : json['calculated'],
        'appliedVouchers': !exists(json, 'appliedVouchers') ? undefined : ((json['appliedVouchers'] as Array<any>).map(VoucherFromJSON)),
        'user': !exists(json, 'user') ? undefined : PrincipalFromJSON(json['user']),
        'pickupOrderGroups': !exists(json, 'pickupOrderGroups') ? undefined : ((json['pickupOrderGroups'] as Array<any>).map(PickupOrderEntryGroupFromJSON)),
        'deliveryOrderGroups': !exists(json, 'deliveryOrderGroups') ? undefined : ((json['deliveryOrderGroups'] as Array<any>).map(DeliveryOrderEntryGroupFromJSON)),
        'pickupItemsQuantity': !exists(json, 'pickupItemsQuantity') ? undefined : json['pickupItemsQuantity'],
        'deliveryItemsQuantity': !exists(json, 'deliveryItemsQuantity') ? undefined : json['deliveryItemsQuantity'],
        'requestedRetrievalAt': !exists(json, 'requestedRetrievalAt') ? undefined : json['requestedRetrievalAt'],
        'sapBillingAddress': !exists(json, 'sapBillingAddress') ? undefined : AddressFromJSON(json['sapBillingAddress']),
        'sapCustomerEmail': !exists(json, 'sapCustomerEmail') ? undefined : json['sapCustomerEmail'],
        'sapPaymentOptionId': !exists(json, 'sapPaymentOptionId') ? undefined : json['sapPaymentOptionId'],
        'paymentType': !exists(json, 'paymentType') ? undefined : B2BPaymentTypeFromJSON(json['paymentType']),
        'purchaseOrderNumber': !exists(json, 'purchaseOrderNumber') ? undefined : json['purchaseOrderNumber'],
        'sapGiftCards': !exists(json, 'sapGiftCards') ? undefined : ((json['sapGiftCards'] as Array<any>).map(SAPGiftCardFromJSON)),
        'sapGiftCardSummary': !exists(json, 'sapGiftCardSummary') ? undefined : SAPGiftCardSummaryFromJSON(json['sapGiftCardSummary']),
        'sapCalculationStatus': !exists(json, 'sapCalculationStatus') ? undefined : SAPCalculationStatusFromJSON(json['sapCalculationStatus']),
        'sapAdditionalTotals': !exists(json, 'sapAdditionalTotals') ? undefined : ((json['sapAdditionalTotals'] as Array<any>).map(SAPAdditionalTotalFromJSON)),
        'sapDiscountSummaries': !exists(json, 'sapDiscountSummaries') ? undefined : ((json['sapDiscountSummaries'] as Array<any>).map(SAPDiscountSummaryFromJSON)),
        'sapAdditionalCostValues': !exists(json, 'sapAdditionalCostValues') ? undefined : ((json['sapAdditionalCostValues'] as Array<any>).map(SAPAdditionalCostValueFromJSON)),
        'sapCustomerFiscalId': !exists(json, 'sapCustomerFiscalId') ? undefined : SAPFiscalIdFromJSON(json['sapCustomerFiscalId']),
        'totalOrderDiscounts': !exists(json, 'totalOrderDiscounts') ? undefined : PriceFromJSON(json['totalOrderDiscounts']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'pakkeboksId': !exists(json, 'pakkeboksId') ? undefined : json['pakkeboksId'],
        'rekvisition': !exists(json, 'rekvisition') ? undefined : json['rekvisition'],
        'entryCode': !exists(json, 'entryCode') ? undefined : json['entryCode'],
        'paymentMode': !exists(json, 'paymentMode') ? undefined : PaymentModeFromJSON(json['paymentMode']),
        'paymentAddress': !exists(json, 'paymentAddress') ? undefined : AddressFromJSON(json['paymentAddress']),
        'flexDeliveryComment1': !exists(json, 'flexDeliveryComment1') ? undefined : json['flexDeliveryComment1'],
        'flexDeliveryComment2': !exists(json, 'flexDeliveryComment2') ? undefined : json['flexDeliveryComment2'],
        'actingUserId': !exists(json, 'actingUserId') ? undefined : json['actingUserId'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDisplay': !exists(json, 'statusDisplay') ? undefined : json['statusDisplay'],
        'guestCustomer': !exists(json, 'guestCustomer') ? undefined : json['guestCustomer'],
        'consignments': !exists(json, 'consignments') ? undefined : ((json['consignments'] as Array<any>).map(ConsignmentFromJSON)),
        'deliveryStatus': !exists(json, 'deliveryStatus') ? undefined : json['deliveryStatus'],
        'deliveryStatusDisplay': !exists(json, 'deliveryStatusDisplay') ? undefined : json['deliveryStatusDisplay'],
        'unconsignedEntries': !exists(json, 'unconsignedEntries') ? undefined : ((json['unconsignedEntries'] as Array<any>).map(OrderEntryFromJSON)),
        'cancellable': !exists(json, 'cancellable') ? undefined : json['cancellable'],
        'returnable': !exists(json, 'returnable') ? undefined : json['returnable'],
        'totalUnitCount': !exists(json, 'totalUnitCount') ? undefined : json['totalUnitCount'],
        'orgCustomer': !exists(json, 'orgCustomer') ? undefined : UserFromJSON(json['orgCustomer']),
        'costCenter': !exists(json, 'costCenter') ? undefined : B2BCostCenterFromJSON(json['costCenter']),
        'permissionResults': !exists(json, 'permissionResults') ? undefined : ((json['permissionResults'] as Array<any>).map(OrderApprovalPermissionResultFromJSON)),
        'orgUnit': !exists(json, 'orgUnit') ? undefined : B2BUnitFromJSON(json['orgUnit']),
        'sapQuoteCode': !exists(json, 'sapQuoteCode') ? undefined : json['sapQuoteCode'],
    };
}

export function OrderToJSON(value?: Order | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'net': value.net,
        'totalPriceWithTax': PriceToJSON(value.totalPriceWithTax),
        'totalPrice': PriceToJSON(value.totalPrice),
        'totalTax': PriceToJSON(value.totalTax),
        'subTotal': PriceToJSON(value.subTotal),
        'deliveryCost': PriceToJSON(value.deliveryCost),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(OrderEntryToJSON)),
        'entryGroups': value.entryGroups === undefined ? undefined : ((value.entryGroups as Array<any>).map(EntryGroupToJSON)),
        'totalItems': value.totalItems,
        'deliveryMode': DeliveryModeToJSON(value.deliveryMode),
        'deliveryAddress': AddressToJSON(value.deliveryAddress),
        'paymentInfo': PaymentDetailsToJSON(value.paymentInfo),
        'appliedOrderPromotions': value.appliedOrderPromotions === undefined ? undefined : ((value.appliedOrderPromotions as Array<any>).map(PromotionResultToJSON)),
        'appliedProductPromotions': value.appliedProductPromotions === undefined ? undefined : ((value.appliedProductPromotions as Array<any>).map(PromotionResultToJSON)),
        'productDiscounts': PriceToJSON(value.productDiscounts),
        'orderDiscounts': PriceToJSON(value.orderDiscounts),
        'totalDiscounts': PriceToJSON(value.totalDiscounts),
        'site': value.site,
        'store': value.store,
        'guid': value.guid,
        'calculated': value.calculated,
        'appliedVouchers': value.appliedVouchers === undefined ? undefined : ((value.appliedVouchers as Array<any>).map(VoucherToJSON)),
        'user': PrincipalToJSON(value.user),
        'pickupOrderGroups': value.pickupOrderGroups === undefined ? undefined : ((value.pickupOrderGroups as Array<any>).map(PickupOrderEntryGroupToJSON)),
        'deliveryOrderGroups': value.deliveryOrderGroups === undefined ? undefined : ((value.deliveryOrderGroups as Array<any>).map(DeliveryOrderEntryGroupToJSON)),
        'pickupItemsQuantity': value.pickupItemsQuantity,
        'deliveryItemsQuantity': value.deliveryItemsQuantity,
        'requestedRetrievalAt': value.requestedRetrievalAt,
        'sapBillingAddress': AddressToJSON(value.sapBillingAddress),
        'sapCustomerEmail': value.sapCustomerEmail,
        'sapPaymentOptionId': value.sapPaymentOptionId,
        'paymentType': B2BPaymentTypeToJSON(value.paymentType),
        'purchaseOrderNumber': value.purchaseOrderNumber,
        'sapGiftCards': value.sapGiftCards === undefined ? undefined : ((value.sapGiftCards as Array<any>).map(SAPGiftCardToJSON)),
        'sapGiftCardSummary': SAPGiftCardSummaryToJSON(value.sapGiftCardSummary),
        'sapCalculationStatus': SAPCalculationStatusToJSON(value.sapCalculationStatus),
        'sapAdditionalTotals': value.sapAdditionalTotals === undefined ? undefined : ((value.sapAdditionalTotals as Array<any>).map(SAPAdditionalTotalToJSON)),
        'sapDiscountSummaries': value.sapDiscountSummaries === undefined ? undefined : ((value.sapDiscountSummaries as Array<any>).map(SAPDiscountSummaryToJSON)),
        'sapAdditionalCostValues': value.sapAdditionalCostValues === undefined ? undefined : ((value.sapAdditionalCostValues as Array<any>).map(SAPAdditionalCostValueToJSON)),
        'sapCustomerFiscalId': SAPFiscalIdToJSON(value.sapCustomerFiscalId),
        'totalOrderDiscounts': PriceToJSON(value.totalOrderDiscounts),
        'comment': value.comment,
        'pakkeboksId': value.pakkeboksId,
        'rekvisition': value.rekvisition,
        'entryCode': value.entryCode,
        'paymentMode': PaymentModeToJSON(value.paymentMode),
        'paymentAddress': AddressToJSON(value.paymentAddress),
        'flexDeliveryComment1': value.flexDeliveryComment1,
        'flexDeliveryComment2': value.flexDeliveryComment2,
        'actingUserId': value.actingUserId,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'status': value.status,
        'statusDisplay': value.statusDisplay,
        'guestCustomer': value.guestCustomer,
        'consignments': value.consignments === undefined ? undefined : ((value.consignments as Array<any>).map(ConsignmentToJSON)),
        'deliveryStatus': value.deliveryStatus,
        'deliveryStatusDisplay': value.deliveryStatusDisplay,
        'unconsignedEntries': value.unconsignedEntries === undefined ? undefined : ((value.unconsignedEntries as Array<any>).map(OrderEntryToJSON)),
        'cancellable': value.cancellable,
        'returnable': value.returnable,
        'totalUnitCount': value.totalUnitCount,
        'orgCustomer': UserToJSON(value.orgCustomer),
        'costCenter': B2BCostCenterToJSON(value.costCenter),
        'permissionResults': value.permissionResults === undefined ? undefined : ((value.permissionResults as Array<any>).map(OrderApprovalPermissionResultToJSON)),
        'orgUnit': B2BUnitToJSON(value.orgUnit),
        'sapQuoteCode': value.sapQuoteCode,
    };
}

